export const REMOVE_COMMENT_REACT_MUTATION = `
  mutation RemoveCommentReactMutation($id: ID!) {
    me {
      removeCommentReact(id: $id) {
        id 
        reactions {
          like
          funny
          helpful
        }
        reacted
      }
    }
  }
`;
